export enum SessionActionType {
    Restore = 1,
    Explore = 2
}
